import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import Filter from 'views/information/filter'; // Importing Filter component
import Table from 'views/information/table'; // Importing Table component
import Details from 'views/information/details'; // Importing Details component
import Record from 'views/information/record'; // Importing Record component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Casino Report View.
 * @extends JetView
 */
export default class CasinoReportView extends JetView {
    /**
     * Configures the layout of the Casino Report View.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const vthis = this; // Reference to the current instance

        // Right section configuration with Record and Details components
        const right = {
            type: 'wide',
            rows: [Record, Details],
        };

        // Alternative right section configuration for smaller screens
        const right2 = {
            height: 1,
            id: 'right2',
            width: screen.width - 54,
            type: 'wide',
            rows: [Record, Details],
        };

        // Toolbar configuration with pagination and export options
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar1',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    id: 'select',
                    options: ['10', '20', '50', '100', '1000'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                            $$('datatable').scrollTo(100, 0); // Scroll to the top
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export1',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export selection
                            var table = $$('datatable'); // Reference to the datatable
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // Calculate first record index
                            var last = first + size - 1; // Calculate last record index
                            if (value !== '') {
                                vthis.app.callEvent('export:filter', [
                                    { value: value, first: first, last: last }, // Trigger export event
                                ]);
                            }
                        },
                    },
                },
            ],
        };

        // Second toolbar configuration for export options
        const toolbar2 = {
            view: 'toolbar',
            id: 'toolbar2',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {},
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export2',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export selection
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable2'); // Reference to the second datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Casino',
                                    ignore: { detailTittle: true, Type: true }, // Ignore certain fields
                                    footer: false, // Do not include footer
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    webix.toPDF($$('datatable2'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Casino',
                                        autowidth: true, // Automatically adjust width
                                        ignore: {
                                            detailTittle: true,
                                            Type: true,
                                        },
                                        footer: false, // Do not include footer
                                    });
                                }
                            }
                            $$('Export2').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };

        // Left section configuration with toolbar, filter, table, and toolbars
        const left = {
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        {
                            view: 'label',
                            label: _('Reporte de casino en vivo'), // Title label
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search', // Search button
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        $$('filterPopup').show(); // Show filter popup on click
                                    },
                                },
                            ],
                        },
                    ],
                },
                Filter, // Filter component
                Table, // Table component
                toolbar, // First toolbar
                toolbar2, // Second toolbar
            ],
        };

        // Advanced details section configuration
        const avanc = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [
                { id: 'dColl', header: _('Detalles Avanzados'), body: right }, // Accordion for advanced details
            ],
        };

        // Advanced details section configuration with responsive behavior
        const avancResp = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'), // Header for advanced details
                    body: right,
                    minWidth: 250,
                    on: {
                        onItemClick: function () {
                            // Event handler for item click
                            var height;
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height(); // Calculate height for scrolling
                                if (!$$('dColl').config.collapsed) {
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                } else {
                                    $$('a5').scrollTo(100, 0); // Scroll to top if collapsed
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Main layout configuration for the Casino Report View
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left section
                        { id: 'res', view: 'resizer' }, // Resizer between sections
                        screen.width < 500 || screen.height < 500
                            ? right2 // Use right2 for small screens
                            : avanc, // Use advanced details for larger screens
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the Casino Report View.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide(); // Hide search button on larger screens
            }
            if (screen.width < 500 || screen.height < 500) {
                $$('res').hide(); // Hide resizer on smaller screens
                var childs = $$('toolbar1').getChildViews(); // Get child views of toolbar1
                $$('toolbar1').removeView(childs[2]); // Remove the third child (export dropdown)
                $$('pagerA').define('group', 1); // Define pager group for smaller screens
            }
            $.fn.scrollBottom = function () {
                // jQuery function to calculate scroll bottom
                return $(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
